import { f7 } from 'framework7-vue';
import { onUnmounted, shallowRef } from 'vue';
import { useI18n } from 'vue-i18n';

// Opens a wallet receipt image in the Framework7 photo browser. Shared by the transaction
// row (TransactionItem.vue) and the transaction detail sheet (TransactionDetailSheet.vue)
// so the standalone-viewer config lives in exactly one place.
//
// Receipt URLs are presigned 30-min TTL links (backend handoff Section 6.5). Must be called from
// component setup — it wires an onUnmounted cleanup for the browser instance.
export function useReceiptPhotoBrowser() {
  const { t } = useI18n();
  const instance = shallowRef(null);

  function openReceipt(url) {
    if (!url) return;
    try {
      if (instance.value) {
        instance.value.destroy();
        instance.value = null;
      }
      instance.value = f7.photoBrowser.create({
        photos: [{ url, caption: t('wallet.transactions.receiptAlt') }],
        type: 'standalone',
        toolbar: true,
        navbar: true,
        closeByBackdropClick: true,
        exposition: true,
        swiper: {
          zoom: { enabled: true, maxRatio: 3, minRatio: 1 },
          keyboard: { enabled: true },
        },
        on: {
          close: () => {
            instance.value?.destroy();
            instance.value = null;
          },
        },
      });
      instance.value.open();
    } catch (err) {
      console.error('Failed to open receipt photo browser:', err);
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  }

  onUnmounted(() => {
    instance.value?.destroy();
    instance.value = null;
  });

  return { openReceipt };
}
